import {createContext, useContext} from 'react';
import {DailyCareLogContextType} from './types';

// Create Context
export const DailyCareLogContext = createContext<DailyCareLogContextType>(
  {} as DailyCareLogContextType
);

// Encapsulated context hook
export const useDailyCareLog = () => useContext(DailyCareLogContext);
